export enum OrderStatus {
    RECEIVED = 'RECEIVED',
    PROCESSING = 'PROCESSING',
    DELIVERED = 'DELIVERED',
    CANCELLED = 'CANCELLED',
    REFUNDED = 'REFUNDED',
    DELAYED = 'DELAYED',
    TERMINATED = 'TERMINATED'
}
